import { render } from "./ThirdPartySale.vue?vue&type=template&id=2bd32c33&scoped=true"
import script from "./ThirdPartySale.vue?vue&type=script&lang=js"
export * from "./ThirdPartySale.vue?vue&type=script&lang=js"

import "./ThirdPartySale.vue?vue&type=style&index=0&id=2bd32c33&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd32c33"]])

export default __exports__